// @flow
import type { FSA } from 'types/redux';
import type { Media } from 'types/media';
import { API_REQUEST } from 'middlewares/api-middleware';
import { DEFAULT_LOCALE } from 'config';

export function emptyMedium(type: string = ''): Media {
  return {
    mediumID: 0,
    type,
    path: '',
    localization: {
      [DEFAULT_LOCALE]: {
        caption: '',
      },
    },
  };
}

export const mediaPath: string = 'media';
export const subscriptionMediaPath: string = 'subscription/media';
export const questMediaPath: string = 'quest/media';
export const abacusMediaPath: string = 'abacus/media';
export const offersdiscoveryPath: string = 'offersdiscovery/media';

function getMediaPath(requestSource: string): string {
  if (['SubscriptionPlanLogo', 'SubscriptionHero'].includes(requestSource)) return subscriptionMediaPath;
  else if (['QuestChallengeCover', 'QuestChallengeLogo'].includes(requestSource)) return questMediaPath;
  else if (['AbacusCampaignCover', 'AbacusCampaignHero'].includes(requestSource)) return abacusMediaPath;
  else if (['CampaignBannerImage'].includes(requestSource)) return offersdiscoveryPath;
  return mediaPath;
}

export const UPLOAD_MEDIUM = 'UPLOAD_MEDIUM';
export function uploadMedium(data: any, requestSource: string): FSA {
  return {
    type: UPLOAD_MEDIUM,
    payload: {
      method: 'POST',
      url: `/${getMediaPath(requestSource)}/upload`,
      data,
    },
    meta: {
      [API_REQUEST]: true,
      requestSource,
    },
  };
}

export const REPLACE_MEDIUM = 'REPLACE_MEDIUM';
export function replaceMedium(oldFileName: string, data: any, requestSource: string): FSA {
  return {
    type: REPLACE_MEDIUM,
    payload: {
      method: 'POST',
      url: `/${getMediaPath(requestSource)}/upload?filename=${oldFileName}`,
      data,
    },
    meta: {
      [API_REQUEST]: true,
      requestSource,
    },
  };
}

export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export function downloadFile(omegaURL: string): FSA {
  return {
    type: DOWNLOAD_FILE,
    payload: {
      method: 'GET',
      url: omegaURL,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_MEDIUM = 'GET_MEDIUM';
export function getMedium(mediumID: number, requestSource: string): FSA {
  return {
    type: GET_MEDIUM,
    payload: {
      method: 'GET',
      url: `/${getMediaPath(requestSource)}/${mediumID}`,
    },
    meta: {
      [API_REQUEST]: true,
      requestSource,
    },
  };
}
